import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/enviroments';
import { SigningDocumentDTO } from './models/signing-document.api.model';

@Injectable({
  providedIn: 'root'
})
export class SigningDocumentService {
    constructor(private http: HttpClient) {}

    /**
     * Fetches the signing document details for a given document GUID.
     * @param documentGuid Document GUID of the signing document to fetch.
     * @returns An Observable containing the SigningDocumentDTO.
     */
    getSigningDocument(documentGuid: string): Observable<SigningDocumentDTO> {
        return this.http.get<SigningDocumentDTO>(`${environment.apiUrl}/v2/SigningDocuments/${documentGuid}`);
    }

    /**
     * Cancel the signing process for a document by its documentGuid.
     * This will send a PATCH request to the API to cancel the signature request.
     * @param documentGuid Document GUID of the document to cancel signing for.
     * @returns An Observable that completes when the request is successful.
     */
    cancelSigningDocument(documentGuid: string): Observable<void> {
        return this.http.patch<void>(`${environment.apiUrl}/v2/SigningDocuments/${documentGuid}/cancel`, {});
    }
}